// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { spacing, fontSize, fontWeight } from 'presentations/views/styles';
import Icon from 'presentations/views/components/atoms/Icon';
import Link from 'presentations/views/components/atoms/Link';
import { pricingPath } from 'presentations/routes/path';
import { PlanId } from 'domains/models/subscription/planId';
import { primary } from 'presentations/views/styles/color';

interface Props {
  className?: string;
  description?: string | null;
  plan: PlanId;
  noLink?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  let label;
  switch (props.plan) {
    case PlanId.Pro:
      label = t('Paid');
      break;
    case PlanId.Team:
      label = t('PaidTeam');
      break;
    case PlanId.Enterprice:
      label = t('PaidEnterprise');
      break;
    default:
      return null;
  }

  return props.noLink ? (
    <PaidNoLink>
      <PaidIcon name="trophy-variant" color="primary" />
      <PaidLabel>{label}</PaidLabel>
    </PaidNoLink>
  ) : (
    <Paid href={pricingPath()} target="_blank">
      <PaidIcon name="trophy-variant" color="primary" />
      <PaidLabel>{label}</PaidLabel>
      <PaidArrowIcon name="chevron-right" color="primary" />
    </Paid>
  );
}

export const Paid = styled(Link)`
  display: flex;
  align-items: center;
`;
const PaidNoLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const PaidLabel = styled.span`
  font-size: ${fontSize(12)};
  font-weight: ${fontWeight('bold')};
  color: ${primary};
`;
export const PaidIcon = styled(Icon)`
  width: 14px !important;
  height: 14px !important;
  margin-right: ${spacing(4)};
`;
export const PaidArrowIcon = styled(Icon)`
  width: 14px !important;
  height: 14px !important;
`;
